import { defineStore } from 'pinia'
import type Producer from '../types/Producer'
import { ref } from 'vue'

export const useProducerStore = defineStore(
  'producer',
  () => {
    const producer = ref<Producer | null>(null)

    const producers = ref<Producer[]>([])

    function setProducer(value: Producer) {
      producer.value = value
    }

    function $reset() {
      producer.value = null
      producers.value = []
    }

    return { producer, producers, setProducer, $reset }
  },
  {
    persist: true,
  },
)
